import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { getCookie } from '../../utilities';
import { ADMIN_TOKEN_COOKIE_NAME } from '../../constants';

function AdminProtectedRoute() {
  const { adminLoggedIn } = useAppSelector((state) => state?.adminAuth);
  const token = getCookie(ADMIN_TOKEN_COOKIE_NAME);
  const location = useLocation();

  if (!adminLoggedIn && !token) {
    return <Navigate to="/admin-portal/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}

export default AdminProtectedRoute;
